export const VESSEL_TRACKING_URL = 'dashboard/vessel_tracking'
export const VESSEL_TRACKING_ERROR = 'VESSEL_TRACKING_ERROR'
export const VESSEL_TRACKING_LOADING = 'VESSEL_TRACKING_LOADING'
export const VESSEL_TRACKING_SUCCESS = 'VESSEL_TRACKING_SUCCESS'

export const VESSEL_TRACKING_VIEW_URL = 'dashboard/vessel_tracking_view'
export const VESSEL_TRACKING_VIEW_ERROR = 'VESSEL_TRACKING_VIEW_ERROR'
export const VESSEL_TRACKING_VIEW_LOADING = 'VESSEL_TRACKING_VIEW_LOADING'
export const VESSEL_TRACKING_VIEW_SUCCESS = 'VESSEL_TRACKING_VIEW_SUCCESS'